import React, { useEffect, useState } from "react"
import { css } from "@jsUtils"
import Img from "gatsby-image/withIEPolyfill"
import { PageSection } from "../PageSection"

import Styles from "./event.module.scss"

/**
 * Event Information
 * @param {object} props - React props
 */
const EventSpeaker = props => {
  const { listOfSpeakers = null, textColor } = props
  const [ready, setReady] = useState(false)

  useEffect(() => {
    const interval = setInterval(() => {
      setReady(true)
    }, 700)
    return () => clearInterval(interval)
  }, [])

  const Speakers = () =>
    listOfSpeakers.map((avatar, index) => (
      <div className={Styles.avatarWrapper}>
        <div className={Styles.child}>
          <Img
            className={Styles.avatarImage}
            fixed={avatar.headshot.fixed}
            alt={`${avatar.firstName} ${avatar.lastName}`}
          />
        </div>
        <div className={Styles.child}>
          {index === 0 && (
            <p className={Styles.eyebrow} style={{ color: textColor }}>
              Moderator
            </p>
          )}
          <p className={Styles.name} style={{ color: textColor }}>
            {avatar.name}
          </p>
          <p className={Styles.title} style={{ color: textColor }}>
            {avatar.title} {avatar.company}
          </p>
        </div>
      </div>
    ))

  if (listOfSpeakers == null) return null

  return (
    <PageSection
      className={css(Styles.section, ready && Styles.ready, Styles.spotlightSection)}
      ready={ready}
      onReady={() => {
        setReady(true)
      }}
    >
      <div className={css(Styles.wrapper, Styles.body)}>
        <Speakers />
      </div>
    </PageSection>
  )
}

export default EventSpeaker
